import type { ReactNode } from "react";
import { ReloadOutlined } from "@ant-design/icons";
import { Button, Spin, Tooltip } from "../ui";
import type { OperationEntry } from "./operationStore";
import { useUiText } from "../ui/uiText";

/** Keeps the value mounted and its geometry intact, but hides stale values from sight and assistive technology. */
export function OperationValue({ entry, retry, retryLabel, errorLabel, children }: {
  entry?: OperationEntry;
  retry: () => void;
  retryLabel: string;
  errorLabel: string;
  children: ReactNode;
}) {
  const failed = entry?.phase === "refreshFailed";
  const { text } = useUiText();
  return <span className="mq-operation-value" aria-busy={entry && !failed ? true : undefined}>
    <span className="mq-operation-value-content" data-hidden={Boolean(entry)} aria-hidden={entry ? true : undefined}>{children}</span>
    {entry ? <span className="mq-operation-value-indicator">
      {failed ? <Tooltip title={entry?.writeUncertain ? text("Write outcome uncertain") : entry?.writeRejected ? text("Rejected action refresh failed") : errorLabel}><Button type="text" disabled={entry?.retryable === false} icon={<ReloadOutlined />} aria-label={retryLabel} onClick={retry} /></Tooltip> : <Spin inline />}
    </span> : null}
  </span>;
}
